import { render, staticRenderFns } from "./BillingAddressFields.vue?vue&type=template&id=4706956c&scoped=true&"
import script from "./BillingAddressFields.vue?vue&type=script&lang=js&"
export * from "./BillingAddressFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4706956c",
  null
  
)

export default component.exports